import EntidadeService from '@/services/entidade.service'

export default {
  namespaced: true,
  state: {
    entidade: null,
    entidades: [],
    loading: false,
    error: null
  },
  mutations: {
    setLoading: (state, loading) => state.loading = loading,
    setError: (state, error) => state.error = error,
    setEntidade: (state, entidade) => state.entidade = entidade,
    setEntidades: (state, entidades) => state.entidades = entidades,
  },
  actions: {
    async ['buscaEntidades']({ commit },
      {
        uf,
        entidadeId
      }
    ) {
      try {
        commit('setLoading', true)
        const data = await EntidadeService.busca(
          uf,
          entidadeId
        )
        commit('setEntidades', data)
      } catch (error) {
        commit('setError', errr)
      } finally {
        commit('setLoading', false)
      }
    }
  },
  getters: {
    getLoading: state => state.loading,
    getError: state => state.error,
    getEntidade: state => state.entidade,
    getEntidades: state => state.entidades,
  }
}
